import { render, staticRenderFns } from "./image-input.vue?vue&type=template&id=655ce73a&scoped=true&"
import script from "./image-input.vue?vue&type=script&lang=ts&"
export * from "./image-input.vue?vue&type=script&lang=ts&"
import style0 from "./image-input.vue?vue&type=style&index=0&id=655ce73a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "655ce73a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardText,VImg})
